// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes homeFadeUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes homeFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}
.homePage .homeDemat {
  padding: clamp(3rem, 7vw, 5rem) 0 clamp(4rem, 8vw, 6rem);
  background: radial-gradient(ellipse 60% 50% at 50% 100%, rgba(63, 185, 234, 0.12), transparent 65%), #f4f7fb;
}
.homePage .homeDemat__inner {
  width: min(1120px, 100% - 2.5rem);
  margin-inline: auto;
  width: min(1120px, 100%);
}
.homePage .homeDemat__band {
  text-align: center;
  padding: clamp(2rem, 5vw, 3rem) clamp(1.25rem, 4vw, 2.5rem);
  background: #ffffff;
  border: 1px solid rgba(26, 31, 44, 0.08);
  border-radius: 28px;
  box-shadow: 0 18px 50px rgba(26, 31, 44, 0.06);
}
.homePage .homeDemat__icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 1rem;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(63, 185, 234, 0.14);
  color: #1a9fd4;
  font-size: 1.35rem;
}
.homePage .homeDemat h2 {
  margin: 0 0 0.5rem;
  font-size: clamp(1.5rem, 3vw, 2.1rem);
  font-weight: 700;
}
.homePage .homeDemat p {
  margin: 0 0 1.5rem;
  color: #5c6578;
  font-size: 1.05rem;
}
.homePage .homeDemat__form {
  max-width: 820px;
  margin: 0 auto;
}
.homePage .homeDemat__fields {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.homePage .homeDemat__fields input {
  width: 100%;
  border: 1px solid rgba(26, 31, 44, 0.08);
  background: #f4f7fb;
  border-radius: 14px;
  padding: 0.9rem 1rem;
  font-size: 0.98rem;
  color: #1a1f2c;
  transition: border-color 0.2s ease, background 0.2s ease;
}
.homePage .homeDemat__fields input::placeholder {
  color: #8a93a5;
}
.homePage .homeDemat__fields input:focus {
  outline: none;
  border-color: #3fb9ea;
  background: #fff;
}
.homePage .homeDemat__submit {
  border: none;
  cursor: pointer;
}

@media (max-width: 767px) {
  .homePage .homeDemat__fields {
    grid-template-columns: 1fr;
  }
  .homePage .homeDemat__submit {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Home/home-tokens.scss","webpack://./src/Components/Home/DematAccount/Style.scss"],"names":[],"mappings":"AA2BA;EACE;IACE,UAAA;IACA,2BAAA;EC1BF;ED4BA;IACE,UAAA;IACA,wBAAA;EC1BF;AACF;AD6BA;EACE;IAEE,wBAAA;EC5BF;ED8BA;IACE,4BAAA;EC5BF;AACF;AAfA;EACE,wDAAA;EACA,4GACE;AAgBJ;AAbE;EDIA,iCAAA;EACA,mBAAA;ECHE,wBAAA;AAgBJ;AAbE;EACE,kBAAA;EACA,2DAAA;EACA,mBDZS;ECaT,wCAAA;EACA,mBAAA;EACA,8CAAA;AAeJ;AAZE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cDzBa;EC0Bb,kBAAA;AAcJ;AAXE;EACE,kBAAA;EACA,qCAAA;EACA,gBAAA;AAaJ;AAVE;EACE,kBAAA;EACA,cD1CS;EC2CT,kBAAA;AAYJ;AATE;EACE,gBAAA;EACA,cAAA;AAWJ;AARE;EACE,aAAA;EACA,qCAAA;EACA,YAAA;EACA,mBAAA;AAUJ;AARI;EACE,WAAA;EACA,wCAAA;EACA,mBD1DM;EC2DN,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cDjEK;ECkEL,wDAAA;AAUN;AARM;EACE,cAAA;AAUR;AAPM;EACE,aAAA;EACA,qBDrEI;ECsEJ,gBAAA;AASR;AAJE;EACE,YAAA;EACA,eAAA;AAMJ;;AAFA;EAEI;IACE,0BAAA;EAIJ;EADE;IACE,WAAA;EAGJ;AACF","sourcesContent":["$home-ink: #1a1f2c;\r\n$home-muted: #5c6578;\r\n$home-line: rgba(26, 31, 44, 0.08);\r\n$home-mist: #f4f7fb;\r\n$home-paper: #ffffff;\r\n$home-teal: #3fb9ea;\r\n$home-teal-deep: #1a9fd4;\r\n$home-red: #d60000;\r\n$home-display: \"Plus Jakarta Sans\", system-ui, sans-serif;\r\n$home-body: \"Outfit\", system-ui, sans-serif;\r\n\r\n@mixin home-container {\r\n  width: min(1120px, calc(100% - 2.5rem));\r\n  margin-inline: auto;\r\n}\r\n\r\n@mixin home-reveal {\r\n  opacity: 0;\r\n  transform: translateY(28px);\r\n  transition: opacity 0.7s ease, transform 0.7s ease;\r\n\r\n  &.is-visible {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes homeFadeUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(24px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes homeFloat {\r\n  0%,\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-12px);\r\n  }\r\n}\r\n","@import \"../home-tokens.scss\";\r\n\r\n.homePage .homeDemat {\r\n  padding: clamp(3rem, 7vw, 5rem) 0 clamp(4rem, 8vw, 6rem);\r\n  background:\r\n    radial-gradient(ellipse 60% 50% at 50% 100%, rgba(63, 185, 234, 0.12), transparent 65%),\r\n    $home-mist;\r\n\r\n  &__inner {\r\n    @include home-container;\r\n    width: min(1120px, 100%);\r\n  }\r\n\r\n  &__band {\r\n    text-align: center;\r\n    padding: clamp(2rem, 5vw, 3rem) clamp(1.25rem, 4vw, 2.5rem);\r\n    background: $home-paper;\r\n    border: 1px solid $home-line;\r\n    border-radius: 28px;\r\n    box-shadow: 0 18px 50px rgba(26, 31, 44, 0.06);\r\n  }\r\n\r\n  &__icon {\r\n    width: 56px;\r\n    height: 56px;\r\n    margin: 0 auto 1rem;\r\n    border-radius: 18px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: rgba(63, 185, 234, 0.14);\r\n    color: $home-teal-deep;\r\n    font-size: 1.35rem;\r\n  }\r\n\r\n  h2 {\r\n    margin: 0 0 0.5rem;\r\n    font-size: clamp(1.5rem, 3vw, 2.1rem);\r\n    font-weight: 700;\r\n  }\r\n\r\n  p {\r\n    margin: 0 0 1.5rem;\r\n    color: $home-muted;\r\n    font-size: 1.05rem;\r\n  }\r\n\r\n  &__form {\r\n    max-width: 820px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  &__fields {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap: 0.75rem;\r\n    margin-bottom: 1rem;\r\n\r\n    input {\r\n      width: 100%;\r\n      border: 1px solid $home-line;\r\n      background: $home-mist;\r\n      border-radius: 14px;\r\n      padding: 0.9rem 1rem;\r\n      font-size: 0.98rem;\r\n      color: $home-ink;\r\n      transition: border-color 0.2s ease, background 0.2s ease;\r\n\r\n      &::placeholder {\r\n        color: #8a93a5;\r\n      }\r\n\r\n      &:focus {\r\n        outline: none;\r\n        border-color: $home-teal;\r\n        background: #fff;\r\n      }\r\n    }\r\n  }\r\n\r\n  &__submit {\r\n    border: none;\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .homePage .homeDemat {\r\n    &__fields {\r\n      grid-template-columns: 1fr;\r\n    }\r\n\r\n    &__submit {\r\n      width: 100%;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
